import { ChannelType } from "src/types/cep";

export type LocalizableChannelType =
  | ChannelType.Email
  | ChannelType.Sms
  | ChannelType.Push
  | ChannelType.Whatsapp;

/**
 * Channels whose messages carry per-recipient translations.
 * An email body is stamped by the composer; SMS and push fields are stored bare and tagged at render.
 */
export function isLocalizableChannel(
  channelType: ChannelType | null,
): channelType is LocalizableChannelType {
  return (
    channelType === ChannelType.Email ||
    channelType === ChannelType.Sms ||
    channelType === ChannelType.Push ||
    channelType === ChannelType.Whatsapp
  );
}

/** A WhatsApp message's settings and translations belong to its template, never the message row. */
export function storesLocalizationOnMessage(
  channelType: ChannelType | null,
): channelType is Exclude<LocalizableChannelType, ChannelType.Whatsapp> {
  return (
    isLocalizableChannel(channelType) && channelType !== ChannelType.Whatsapp
  );
}
